import * as React from 'react';
export const IcRotate90 = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.71 8.79c-.33-.33-.84-.36-1.22-.13v-.68c0-2.73-2.24-4.96-5-4.96-.55 0-1 .45-1 1s.45 1 1 1c1.65 0 3 1.33 3 2.96v.69a.989.989 0 00-1.17.17.996.996 0 000 1.41l1.44 1.44c.18.19.44.32.72.32.27 0 .52-.11.71-.29l1.51-1.51a.996.996 0 000-1.41l.01-.01zM12.39 8H5.65a2.63 2.63 0 00-2.63 2.63v6.74A2.63 2.63 0 005.65 20h6.74a2.63 2.63 0 002.63-2.63v-6.74A2.63 2.63 0 0012.39 8z'
      fill='currentColor'
    />
  </svg>
);
